import {
  PERIODS_CHANGE_RP_STATUS_BEGIN,
  PERIODS_CHANGE_RP_STATUS_SUCCESS,
  PERIODS_CHANGE_RP_STATUS_FAILURE,
  PERIODS_CHANGE_RP_STATUS_DISMISS_ERROR,
} from './constants';


import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';

let tableRef = null;


// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function changeRpStatus(_tableRef, reporting_number, completion_date, action, project,args = {}) 
{
  tableRef = _tableRef;
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: PERIODS_CHANGE_RP_STATUS_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let reporting_period = {
        "reporting_number":reporting_number+'',
        "rp_status":"2",
        "completion_date":completion_date,
        "project": project,
        }
      if(action === 2)
      {
        reporting_period = {
        "reporting_number":reporting_number+'',
        "completion_date":completion_date,
        "project":project,
        }
      }
       axios.post(SERVER_PATH + '/projects/editRP',{
        reporting_period:reporting_period
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          dispatch({
            type: PERIODS_CHANGE_RP_STATUS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PERIODS_CHANGE_RP_STATUS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissChangeRpStatusError() {
  return {
    type: PERIODS_CHANGE_RP_STATUS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PERIODS_CHANGE_RP_STATUS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        changeRpStatusPending: true,
        changeRpStatusError: null,
      };

    case PERIODS_CHANGE_RP_STATUS_SUCCESS:
      tableRef.current && tableRef.current.onQueryChange();
      // The request is success
      return {
        ...state,
        changeRpStatusPending: false,
        changeRpStatusError: null,
      };

    case PERIODS_CHANGE_RP_STATUS_FAILURE:
      // The request is failed
      return {
        ...state,
        changeRpStatusPending: false,
        changeRpStatusError: action.data.error,
      };

    case PERIODS_CHANGE_RP_STATUS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        changeRpStatusError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/periods/redux/changeRpStatus.js